import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import QRCode from "react-qr-code";

const AssetQrCode = ({ qrDialogOpen, setQrDialogOpen, selectedAsset }) => {
  const rawBarcode =
    selectedAsset?.BarCode ??
    selectedAsset?.barCode ??
    selectedAsset?.QrCode ??
    selectedAsset?.qrCode;

  const barcodeValue =
    rawBarcode && typeof rawBarcode === "string"
      ? rawBarcode.trim()
      : rawBarcode
      ? String(rawBarcode).trim()
      : "";

  if (!barcodeValue || barcodeValue.toLowerCase() === "null" || barcodeValue.toLowerCase() === "undefined") {
    return null;
  }

  return (
    <Dialog open={qrDialogOpen} onClose={() => setQrDialogOpen(false)} maxWidth="xs" fullWidth>
      <DialogTitle>Asset QR Code</DialogTitle>
      <DialogContent dividers>
        <Box
          sx={{
            py: 2,
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            gap: 2
          }}
        >
          <QRCode value={barcodeValue} size={180} />
          <Typography variant="body2" sx={{ color: "text.secondary", fontWeight: 600 }}>
            {barcodeValue}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={() => setQrDialogOpen(false)}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default AssetQrCode;